import { render, staticRenderFns } from "./OurHistory.vue?vue&type=template&id=079c7f7e&scoped=true&"
import script from "./OurHistory.vue?vue&type=script&lang=js&"
export * from "./OurHistory.vue?vue&type=script&lang=js&"
import style0 from "./OurHistory.vue?vue&type=style&index=0&id=079c7f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c7f7e",
  null
  
)

export default component.exports